import { render } from "./nuevoPost.vue?vue&type=template&id=508567fc&scoped=true"
import script from "./nuevoPost.vue?vue&type=script&lang=js"
export * from "./nuevoPost.vue?vue&type=script&lang=js"

import "./nuevoPost.vue?vue&type=style&index=0&id=508567fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508567fc"]])

export default __exports__